/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Created_Year_LabelInputs */

const en_admin_user_list_created_year_label = /** @type {(inputs: Admin_User_List_Created_Year_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year of creation`)
};

const de_admin_user_list_created_year_label = /** @type {(inputs: Admin_User_List_Created_Year_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahrgang`)
};

/**
* | output |
* | --- |
* | "Year of creation" |
*
* @param {Admin_User_List_Created_Year_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_created_year_label = /** @type {((inputs?: Admin_User_List_Created_Year_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Created_Year_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_created_year_label(inputs)
	return en_admin_user_list_created_year_label(inputs)
});